<template>
    <vx-card title="Добавить страну" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <v-select
                        :options="dicts.countries"
                        @input="enableSubmitButton()"
                        placeholder="Выберите страну"
                        label="name"
                        class="w-full"
                        v-model="form.country"
                        
                    >
                    </v-select>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        @input="enableSubmitButton()"
                        v-model="form.cpcStandard"
                        :danger="!!errors.cpcStandard"
                        :danger-text="errors.cpcStandard"
                        autocomplete="off"
                        label="Норма CPC"
                        class="mt-1 w-full required"
                        type="number"
                    />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        @input="enableSubmitButton()"
                        v-model="form.buyoutPercent"
                        :danger="!!errors.buyoutPercent"
                        :danger-text="errors.buyoutPercent"
                        autocomplete="off"
                        label="Процент выкупаемого трафика аукциона"
                        class="mt-1 w-full required"
                        type="number"
                    />
                </div>
            </div>
        </div>

        <vs-button id="submitSaveCountry" class="mt-5 mr-2" color="success" @click="saveCountry()" disabled type="filled"> Сохранить </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled"> Отмена </vs-button>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'teaser-buying-dashboard-country-create',
    data() {
        return {
            dicts: {
                countries: []
            },
            form: {
                buyingTypeId: 4,
                countryId: undefined,
                cpcStandard: undefined,
                buyoutPercent: undefined
            },
            errors: {
                name: '',
                AdTagCategoryId: '',
                buyoutPercent: ''
            }
        };
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .all([this.axios.get('dashboardBuyingTypeCountries/dicts')])
                .then(
                    axios.spread((dicts) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.setDictionaries(dicts.data);
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки списка стран.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        saveCountry() {
            if (!this.form.cpcStandard) {
                this.$vs.notify({
                    title: 'Ошибка!',
                    text: 'Введите CPC норму',
                    color: 'danger'
                });
            }

            if (!this.form.buyoutPercent) {
                this.$vs.notify({
                    title: 'Ошибка!',
                    text: 'Введите процент выкупаемого трафика аукциона',
                    color: 'danger'
                });
            }

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            const params = {
                buyingTypeId: 4,
                countryId: this.form.country.id,
                cpcStandard: this.form.cpcStandard,
                buyoutPercent: this.form.buyoutPercent
            };
            this.$axios({
                method: 'POST',
                url: 'DashboardBuyingTypeCountries',
                params: params,
                errors: this.errors,
                success: (user) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно добавлено',
                        text: 'Страна успешно добавлена',
                        color: 'success'
                    });
                    this.$router.push('/settingsTeaserBuying');
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Ошибка при добавлении тега!',
                        text: err.response.data,
                        color: 'danger'
                    });
                }
            });
        },
        cancelEdit() {
            this.$router.push('/settingsTeaserBuying');
        },
        enableSubmitButton() {            
            if (this.form.buyoutPercent && this.form.cpcStandard && this.form.country) {
                document.getElementById('submitSaveCountry').disabled = false;
            }
            else
            {
                document.getElementById('submitSaveCountry').disabled = true;
            }
        },
        setDictionaries(dicts) {
           
            const dictCountries = [];
            dicts.countries.forEach((c) => {
                dictCountries.push(c);
            });
            this.dicts.countries = dictCountries;            
        },
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style>
.select-error > div {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
}
</style>